module.exports = __webpack_public_path__ + "img/step3-c.28058f49.png";